import { Injectable } from "@angular/core";
import { AppSettings } from "../shared/AppSettings";
import { HttpClient } from "@angular/common/http";
import { ClientModel } from "../model/clientModel";
import { SupportCallModel } from "../model/SupportCallModel";

import { NewCallRequest } from "../model/newCallRequest";
import { CallTypeModel } from "../model/callType";
import { CallFollowUp } from "../model/callFollowUp";
import { CallDetailItem } from "../model/callDetailItem";
import { UpdateOrderNumberRequest } from "../model/updateOrderNumberRequest";
import { SendSupplierRequest } from "../model/sendSupplierRequest";
import { CallEmailHistoryModel } from "../model/callEmailHistoryModel";
import {
  SendUserRequest,
  UserWithSupplierDto,
} from "../model/userWithSupplierDTO";
import { CallsReportDto } from "../model/callsReportDto";
import { UpdateCallTypeForCallModel } from "../model/updateCallTypeForCallModel";

@Injectable()
export class ClientService {
  readonly rootUrl = AppSettings.webApiURL;

  constructor(public httpClient: HttpClient) {}

  addClient = (client: ClientModel) => {
    return this.httpClient.post<boolean>(
      `${this.rootUrl}/api/ItemController/AddClient`,
      client,
    );
  };

  getAllClients() {
    return this.httpClient.get<ClientModel[]>(
      `${this.rootUrl}/api/ItemController/GetAllClients`,
    );
  }

  updateClient(client: ClientModel) {
    return this.httpClient.put<boolean>(
      `${this.rootUrl}/api/ItemController/UpdateClient`,
      client,
    );
  }

  deleteClient(id: number) {
    return this.httpClient.delete<boolean>(
      `${this.rootUrl}/api/ItemController/DeleteClient/${id}`,
    );
  }

  addNewCallRequest(callData: NewCallRequest) {
    return this.httpClient.post<boolean>(
      `${this.rootUrl}/api/ItemController/AddNewCallRequest`,
      callData,
    );
  }

  getAllCallTypes() {
    return this.httpClient.get<CallTypeModel[]>(
      `${this.rootUrl}/api/ItemController/GetAllCallTypes`,
    );
  }

  getClientById(clientId: number) {
    return this.httpClient.get<ClientModel>(
      `${this.rootUrl}/api/ItemController/GetClientById?clientId=${clientId}`,
    );
  }

  getAllRelatedCalls(clientId: number) {
    return this.httpClient.get<SupportCallModel[]>(
      `${this.rootUrl}/api/ItemController/GetAllRelatedCalls?clientId=${clientId}`,
    );
  }

  getCallDetailsById(callId: number) {
    return this.httpClient.get<SupportCallModel>(
      `${this.rootUrl}/api/ItemController/GetCallDetailsById?callId=${callId}`,
    );
  }

  newFollowUpCall = (followUpCall: CallFollowUp) => {
    return this.httpClient.post<boolean>(
      `${this.rootUrl}/api/ItemController/AddFollowUpCall`,
      followUpCall,
    );
  };

  // client.service.ts
  getCallDetailsHistory(callId: number) {
    return this.httpClient.get<CallDetailItem[]>(
      `${this.rootUrl}/api/ItemController/GetCallDetailsHistory?callId=${callId}`,
    );
  }

  toggleCallStatus(callId: number) {
    return this.httpClient.post<boolean>(
      `${this.rootUrl}/api/ItemController/ToggleCallStatus`,
      callId,
    );
  }

  updateOrderNumber(data: UpdateOrderNumberRequest) {
    return this.httpClient.post<boolean>(
      `${this.rootUrl}/api/ItemController/UpdateOrderNumber`,
      data,
    );
  }

  sendToSupplier(formData: FormData) {
    return this.httpClient.post<any>(
      `${this.rootUrl}/api/ItemController/SendToSupplier`,
      formData,
    );
  }

  getCallEmailHistory(callId: number) {
    return this.httpClient.get<CallEmailHistoryModel[]>(
      `${this.rootUrl}/api/ItemController/GetCallEmailHistory/${callId}`,
    );
  }

  getAllUsersWithActiveSupplier = () => {
    return this.httpClient.get(
      `${this.rootUrl}/api/ItemController/GetAllUsersWithActiveSupplier`,
    );
  };

  sendToUser(formData: FormData) {
    return this.httpClient.post<any>(
      `${this.rootUrl}/api/ItemController/SendToUser`,
      formData,
    );
  }

  getAllUsersWithoutSupplier() {
    return this.httpClient.get<UserWithSupplierDto[]>(
      `${this.rootUrl}/api/ItemController/GetAllUsersWithoutSupplier`,
    );
  }

  sendToUserWithoutSupplier(formData: FormData) {
    return this.httpClient.post<any>(
      `${this.rootUrl}/api/ItemController/SendToUserWithoutSupplier`,
      formData,
    );
  }

  send(
    endpoint: "user" | "userWithoutSupplier" | "supplier",
    formData: FormData,
  ) {
    switch (endpoint) {
      case "user":
        return this.httpClient.post(
          `${this.rootUrl}/api/ItemController/SendToUser`,
          formData,
        );

      case "userWithoutSupplier":
        return this.httpClient.post(
          `${this.rootUrl}/api/ItemController/SendToUserWithoutSupplier`,
          formData,
        );

      case "supplier":
        return this.httpClient.post(
          `${this.rootUrl}/api/ItemController/SendToSupplier`,
          formData,
        );
    }
  }

  getCallsReport = () => {
    return this.httpClient.get<CallsReportDto[]>(
      `${this.rootUrl}/api/ItemController/GetCallsReport`,
    );
  };

  deleteCallType(callTypeId: number) {
    return this.httpClient.delete(
      `${this.rootUrl}/api/ItemController/DeleteCallType/${callTypeId}`,
    );
  }

  updateCallType(callType: CallTypeModel) {
    return this.httpClient.put(
      `${this.rootUrl}/api/ItemController/UpdateCallType`,
      callType,
    );
  }

  addCallType(callType: CallTypeModel) {
    return this.httpClient.post(
      `${this.rootUrl}/api/ItemController/AddCallType`,
      callType,
    );
  }

  updateCallTypeForCall = (updateModel: UpdateCallTypeForCallModel) => {
    return this.httpClient.post(
      `${this.rootUrl}/api/ItemController/UpdateCallTypeForCall`,
      updateModel,
    );
  };
}



// WEBPACK FOOTER //
// C:/MyProjects_Git/GoDocu/GoDocuMng/Client/src/app/service/client.service.ts